export const convertToText = (timeInMinutes) => {
  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;
  return `${hours.toString().length < 2 ? "0" + hours : hours}:${
    minutes.toString().length < 2 ? "0" + minutes : minutes
  }`;
};
